<header class="header-container">
  <div *ngIf="!isCasasBahia" class="header-content">
    <img [src]="assets.brand" alt="portal do carne bahia">
    <button (click)="handleAcessAccount()" type="button" mat-flat-button class="btn-continue" color="primary">
      Acesse sua conta
    </button>
  </div>

  <div *ngIf="isCasasBahia" class="header-content-cb">
    <div class="brand-container">
      <a href="https://www.casasbahia.com.br/" target="_blank">
        <img src="assets/images/new-brand-cb-text.svg">
      </a>
      <hr>
    </div>

    <div class="brand-name-container">
      <div class="brand-name">
        <h1>Pagamento e renegociação</h1>
        <h2>Carnê e cartão</h2>
      </div>
      <button (click)="handleAcessAccount()" type="button" mat-flat-button class="btn-continue" color="primary">
        Acesse sua conta
      </button>
    </div>
  </div>

  <div *ngIf="!isCasasBahia" class="header-content-mobile">
    <img [src]="assets.brandMascot" class="maskot-img" alt="cb">
    <img [src]="assets.brandVert" class="brand-vert" alt="portal do carne bahia">
  </div>
</header>